import React from "react";

function Skills() {
  return (
    <div className="pt-8 pb-8 bg-neutral-600" id="skills">
      <div className="container mx-auto">
        <div className="flex flex-col">
          <h4 className="text-2xl text-white font-semibold">Skills</h4>
          <div className="p-8">
            <p className="text-xl text-white pb-2 pt-2">JavaScript</p>
            <div className="w-full bg-gray-200  h-6 dark:bg-gray-700 pb-2">
              <div
                className="bg-gray-800 h-6 pb-2"
                style={{ width: "85%" }}
              ></div>
            </div>
            <p className="text-xl text-white pb-2 pt-2">ReactJS</p>
            <div className="w-full bg-gray-200 h-6 dark:bg-gray-700">
              <div className="bg-gray-800 h-6" style={{ width: "75%" }}></div>
            </div>
            <p className="text-xl text-white pb-2 pt-2">GIT</p>
            <div className="w-full bg-gray-200 h-6 dark:bg-gray-700">
              <div className="bg-gray-800 h-6" style={{ width: "55%" }}></div>
            </div>
            <p className="text-xl text-white pb-2 pt-2">HTML</p>
            <div className="w-full bg-gray-200 h-6 dark:bg-gray-700">
              <div className="bg-gray-800 h-6" style={{ width: "95%" }}></div>
            </div>
            <p className="text-xl text-white pb-2 pt-2">CSS</p>
            <div className="w-full bg-gray-200 h-6 dark:bg-gray-700">
              <div className="bg-gray-800 h-6" style={{ width: "85%" }}></div>
            </div>
            <p className="text-xl text-white pb-2 pt-2">NodeJS</p>
            <div className="w-full bg-gray-200 h-6 dark:bg-gray-700">
              <div className="bg-gray-800 h-6" style={{ width: "35%" }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
